import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'

import { ErrorBoundary } from '@scoir/error-reporter'
import produce from 'immer'

import Modal from './Modal'
export { MODE_EDIT, MODE_EDIT_DRAFT, MODE_CREATE, MODE_COPY } from './Modal'

const EditModal = ({
  show = false,
  mode,
  messageHasChanged,
  message,
  setMessage,
  onHide,
  onSave,
  isSaving = false,
}) => {
  const [enforceFocus, setEnforceFocus] = useState(true)

  const updateMessage = useCallback(
    (property, value) => {
      setMessage(
        produce(message, (draftState) => {
          draftState[property] = value
        }),
      )
    },
    [message, setMessage],
  )

  const toggleEnforceFocus = useCallback(() => {
    setEnforceFocus(!enforceFocus)
  }, [enforceFocus])

  return (
    <ErrorBoundary>
      <Modal
        enforceFocus={enforceFocus}
        show={show}
        mode={mode}
        message={message}
        allowedToSave={show && messageHasChanged()}
        onHide={(_event, reason) => {
          if (reason && reason === 'backdropClick') return
          setEnforceFocus(true)
          onHide()
        }}
        onSave={onSave}
        isSaving={isSaving}
        onUpdate={updateMessage}
        onToggleEnforceFocus={toggleEnforceFocus}
      />
    </ErrorBoundary>
  )
}

EditModal.propTypes = {
  message: PropTypes.object,
  show: PropTypes.bool.isRequired,
  mode: PropTypes.string,
  messageHasChanged: PropTypes.func.isRequired,
  setMessage: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
}

export default EditModal
